"use client";
import { useRouter } from "next/navigation";
import { isEmpty, isString, isObject, some, includes } from "utils/lodash";
import routeStore from "utils/routeStore";
import { useI18n } from "providers/I18nProvider";
import { localizePath } from "utils/locale";
// const pathList = ["/shop", "/search"];
const useRoute = () => {
  const nextRouter = useRouter();
  const { locale } = useI18n();
  // Giữ tiền tố ngôn ngữ khi chuyển trang bằng code (vd bấm gợi ý tìm kiếm),
  // nếu không khách đang xem bản tiếng Anh sẽ bị rơi về trang tiếng Việt.
  const withLocale = (path: any) =>
    typeof path === "string" ? localizePath(path, locale) : path;
  const router = {
    ...nextRouter,
    push: (pathname: any, params?: { [key: string]: any }) => {
      if (!isEmpty(params)) {
        nextRouter.push(withLocale(pathname));

        let _params = params;
        routeStore.resetRedirect();
        if (!isEmpty(params.redirect)) {
          const { redirect, ...rest } = params;
          if (isString(redirect)) {
            routeStore.setRedirect({ pathname: redirect });
          } else if (isObject(redirect)) {
            routeStore.setRedirect(redirect);
          }
          _params = rest;
        }
        routeStore.setParams(_params);
      }
      nextRouter.push(withLocale(pathname));
    },
    handleDeepLink: (url: string) => {
      const isDubLink = url.includes("s.lookme.vn");
      if (isDubLink) {
        window.open(url, "_blank");
      } else {
        // const isPathMatch = some(pathList, (path) => {
        //   return includes(url, path);
        // });
        // if (isPathMatch) {
        nextRouter.push(withLocale(url));
        // }
      }
    },
  };
  return router;
};
export default useRoute;
